
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';


import { TokenInterceptor } from "app/authorized-http.service";
import { IData } from "app/text-content/utils";
import { ContentTextResource } from "app/models/ContentTextResource";
import { ContentTextResource2 } from "app/models/ContentTextResource2";
import { ContentCommonResource } from "app/models/ContentCommonResource";
import { ContentCommonFileListResource } from "app/models/ContentCommonFileListResource";
import { TagListResource } from "app/models/TagListResource";
import { HttpClient , HttpHeaders} from "@angular/common/http";
import { environment } from "app/baseUrl";

@Injectable()
export class TextContentService {

	constructor(private http: HttpClient,private httpa: TokenInterceptor) { }

	getContent(url): Observable<ContentTextResource2> {
		return this.http.get<ContentTextResource2>(environment['url'] + url)
	}
	isOnButton(url): Observable<String> {
		return this.http.get<String>(environment['url'] + url)
	}
	generateLink(url): Observable<String> {
		const headers = new HttpHeaders({
			'Content-Type':  'text/plain; charset=utf-8'
		  //   'Accept': 'text/html'
		  })
		return this.http.get<String>(environment['url'] + url, {headers, responseType: 'text' as 'json' })
	}
	save(url, body): Observable<ContentTextResource> {
		return this.http.post<ContentTextResource> (environment['url'] + url, body)
	}

	delete(url, body): Observable<ContentTextResource> {
		return this.http.post<ContentTextResource> (environment['url'] + url, body)
	}

	getDocumentList(url): Observable<ContentCommonFileListResource> {
		return this.http.get<ContentCommonFileListResource> (environment['url'] + url)
	}

	private handleError(error: Response | any) {
		// In a real world app, you might use a remote logging infrastructure
		let errMsg: string;
		if (error instanceof Response) {
			const body = error.json() || ''
			const err = body.error || JSON.stringify(body);
			errMsg = `${error.status} - ${error.statusText || ''} ${err}`
		} else {
			errMsg = error.message ? error.message : error.toString()
		}
		console.error(errMsg)
		return observableThrowError(errMsg)
	}

	uploadPdf(url, body): Observable<any> {
		return this.http.post(environment['url'] + url, body)
	}
	
	uploadDoc(url, body): Observable<any> {
		return this.http.post(environment['url'] + url, body)
	}

	deletePdfAndDoc(url): Observable<ContentCommonResource> {
		return this.http.get<ContentCommonResource> (environment['url'] + url)
	}

	getContentCommon(url): Observable<ContentCommonResource> {
		return this.http.get<ContentCommonResource> (environment['url'] + url)
	}

	getContentCommonDoc(url): Observable<ContentCommonResource> {
		return this.http.get<ContentCommonResource> (environment['url'] + url)
	}

	multipleDeleteDocuments(url, body): Observable<ContentCommonFileListResource> {
		return this.http.post<ContentCommonFileListResource>(environment['url'] + url, body)
	}

	getAllTags(url): Observable<TagListResource> {
		return this.http.get<TagListResource>(environment['url'] + url)
	}

}
